<i18n src="../../locales/lang.json"></i18n>

<template>
  <div>
    <modal-no-ref v-bind:title="$t('select_site')" ref="thisModal" v-bind:onsave="doSave" size="modal-xs mx-4 mt-5  mt-md-4 mx-md-auto">
      <div class="card mb-0 border-0 shadow-0">
        <div class="card-body pt-2">
          <div class="text-center mb-2">
            <i class="icon-reading icon-2x text-slate-300 border-slate-300 border-3 rounded-pill p-3 mb-2 mt-1"></i>
            <h5 class="mb-0">{{$t('select_site_title')}}</h5>
            <span class="d-block text-muted">{{$t('select_site_description')}}</span>
          </div>
          <div class="form-group form-group-feedback form-group-feedback-left">
            <div class="row">
              <div class="col-sm-12">
                <select id="selectSites" class="form-control select" name="siteid" @change="onChange">
                  <option value="">{{$t('select_site')}}</option>
                  <option v-for="site in sites" v-bind:value="site.Siteid">{{site.Name}}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </modal-no-ref>
  </div>

</template>

<script>

  import ModalNoRef from "../modals/modal-no-ref.vue";
  var sites = [];
  var selected = "";

  export default {
    name: "login-select-site",
    components: {
      ModalNoRef
    },
    props: {
      user: {
        type: String,
        default: ""
      },
      url: {
        type: String,
        default: ""
      },

    },
    data() {
      return {
        sites,
        selected
      };
    },
    methods: {
      openLogin() {
        this.close();
        this.$parent.open();
      },
      open() {
        this.$refs.thisModal.open();
      },
      selectSite(selected) {
        if (this.sites != null && this.sites.length > 0) {
          //var filSite = this.sites.filter(n => n.UniqueId == selected);
          let filSite = this.sites.find(obj => {
            return obj.UniqueId === selected
          })

          console.log(filSite);
          if (filSite !== null && filSite !== undefined) {
            //alert(filSite.Siteid);
            setTimeout(function () {              
              $("#selectSites").val(filSite.Siteid);
              $("#selectSites").trigger('change');
            }, 100);

            //alert($("#selectSites").val());
          }
        }
      },
      close() {
        this.$refs.thisModal.close();
      },

      handleRefresh(val) {
        this.$forceUpdate();
      },
      setSites(sites) {
        this.sites = sites;
        $("#selectSites").change(this.onChange);
      },
      onChange() {
        this.setSelectedSite($("#selectSites").val())
      },

      async setSelectedSite(siteId) {
        //location.href = '/sites/SetSite?id=' + siteId;        
        var thisContext = this;
        try {
          this.$http.get('/Sites/SetSelectedSite?siteid=' + siteId)
            .then(function (response) {
              if (thisContext.url != null && thisContext.url != "") {
                location.href = thisContext.url;
              }
              else {
                var redirectUrl = response.data;
                location.href = redirectUrl;
              }

            });
        }
        catch (err) {
          alert('some error:' + err)
        }        
      },
    },
    computed: {

    },
    watch: {

    },
    mounted() {
      $('#selectSites').select2();
    },
    created() {

    },
  };

</script>



// WEBPACK FOOTER //
// src/components/login/login-select-site.vue